import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

/**
 * Component to handle Android hardware back button
 * Navigates back in React Router history instead of exiting the app
 */
export function AndroidBackButtonHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only handle back button on native Android platform
    if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') {
      return;
    }

    // Listen for back button press
    const backButtonListener = App.addListener('backButton', () => {
      // Check if we're on a root/home page
      const isRootPage = 
        location.pathname === '/' ||
        location.pathname === '/contractors' ||
        location.pathname === '/contractor-dashboard';

      if (isRootPage) {
        // On root page, exit the app
        App.exitApp();
      } else {
        // Not on root page, navigate back
        navigate(-1);
      }
    });

    // Cleanup listener on unmount
    return () => {
      backButtonListener.then(listener => listener.remove());
    };
  }, [navigate, location.pathname]);

  return null; // This component doesn't render anything
}
